




















import { Component, Vue } from 'vue-property-decorator';
import { AgGridVue } from 'ag-grid-vue';
import { asociacionEventBus } from '@/setup';

@Component({
  components: {
    AgGridVue,
  },
})
export default class GridResumen extends Vue {
  columnDefs: any[] = [];
  show: boolean = false;
  rowData: any[] = [];
  showData: any[] = [];
  rowSelection: any[] = [];
  rows: any[] = [
    {
      rut_transportista: '903200006',
      nom_transportista: 'COMPAÑIA ELECTRO METALURGICA S.A.',
      cod_grupovehiculo: '2654323',
      plataforma: 'NAVMAN',
      cod_flota: '-1',
      cod_vehiculo: '-1',
      id: '27',
      flota: 'TODAS',
      grupo: 'ELECMETAL',
      vehiculo: 'TODOS',
    },
  ];
  mounted() {
    this.columnDefs = [
      {
        headerName: 'Check',
        field: 'check',
        minWidth: 180,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
      },
      { field: 'patente' },
      { field: 'grupo' },
      { field: 'flota' },
      { field: 'transportista' },
    ];
    this.getRowData();
    asociacionEventBus.$on(
      'asignacionVehiculoTransportista',
      (selecciones: any) => {
        selecciones.map((seleccion: any) => {
          this.rowData = [...this.rowData, seleccion];
        });
      }
    );
  }

  getRowData() {
    this.rows.map(row => {
      let auxRow = {
        patente: row.vehiculo, // ! hay que obtener la patente de alguna forma
        grupo: row.grupo,
        flota: row.flota,
        transportista: row.nom_transportista,
      };
      this.rowData = [...this.rowData, auxRow];
    });
    console.log(this.rowData);
  }
}
